<h2 mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white">
    {{ref?.setting?.page_heading}}
</h2>

<mat-dialog-content style="max-height: none; flex: 1">
    <tt-add-existing-doc-arc #ref [params]="params"></tt-add-existing-doc-arc>
</mat-dialog-content>
